<template>
  <div class="pb-10">
    <h1 class="text-4.3xl font-title uppercase text-center pb-5 md:pb-3.5 md:pt-6 border-[#050708] border-b">Products & Services</h1>
    <div v-if="ready" class="flex space-x-2 mb-3 relative lg:mt-10">
      <div class="md:w-[230px] lg:w-[350px] top-0  absolute md:sticky md:top-2" :class="showListResults === true? 'left-0':'left-[-252px]'">
        <div class="relative z-10 bg-white" :class="showListResults === true? 'drop-shadow-2xl':''">
<!--          <div class=" p-4 mb-2">-->
<!--            <h2 class="uppercase text-base font-semibold tracking-wide font-['Open_Sans', 'sans_serif'] text-grayDark">NARROW YOUR RESULTS</h2>-->
<!--            <input class="py-2 px-3 border focus:outline-none focus:ring-slate-500 rounded-xl focus:ring-slate-500 mt-5"-->
<!--                   placeholder="Search"-->
<!--                   type="text"-->
<!--                   v-model="search"-->
<!--                   @input="searchProduct()">-->
<!--          </div>-->
<!--          <div class="col-span-3  mb-2 p-4">-->
<!--            <h2 class="uppercase text-base font-semibold tracking-wide font-['Open_Sans', 'sans_serif'] text-grayDark">Displaying: {{perPage}} / {{products.length}}</h2>-->
<!--            <div class="grid grid-cols-1 sm:grid-cols-2">-->
<!--              <select-->
<!--                  v-model="perPage"-->
<!--                  class="mt-1 py-2 px-3 border focus:outline-none focus:ring-slate-500 max-w-[70px] focus:border-slate-500 mt-5">-->
<!--                <option>12</option>-->
<!--                <option>18</option>-->
<!--                <option>24</option>-->
<!--              </select>-->
<!--              <div class="flex flex-row justify-end items-center">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">-->
<!--                  <path d="M9.375 233.4l128-128c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H480c17.69 0 32 14.31 32 32s-14.31 32-32 32H109.3l73.38 73.38c12.5 12.5 12.5 32.75 0 45.25c-12.49 12.49-32.74 12.51-45.25 0l-128-128C-3.125 266.1-3.125 245.9 9.375 233.4z" fill="#808080"/>-->
<!--                </svg>-->
<!--                <div v-for="index in numPages" :key="index">-->
<!--                  <button-->
<!--                      class="h-7 w-7 text-xl inline-block text-center"-->
<!--                      @click="currentPage=index-1"-->
<!--                      :class="currentPage===index-1 ? 'text-white rounded-lg bg-darkRed' : 'text-black'"-->
<!--                  >{{ index }}-->
<!--                  </button>-->
<!--                </div>-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">-->
<!--                  <path d="M502.6 278.6l-128 128c-12.51 12.51-32.76 12.49-45.25 0c-12.5-12.5-12.5-32.75 0-45.25L402.8 288H32C14.31 288 0 273.7 0 255.1S14.31 224 32 224h370.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z" fill="#808080"/>-->
<!--                </svg>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="border-black border p-4 mb-2">
            <h2 class="uppercase text-base font-semibold tracking-wide font-['Open_Sans', 'sans_serif'] text-grayDark border-black border-b py-2">categories</h2>
            <ul class="max-h-80 text-veryDarkGray overflow-hidden overflow-y-scroll mt-6">
              <li v-for="category in categories" class="my-1.5 text-base">
                <label class="uppercase font-semibold relative pl-9 block group">{{category.name}}
                  <input type="checkbox" class="peer opacity-0" @click="checkedCategories(category.name)">
                  <span class="absolute top-0 left-0 h-6 w-6 bg-white border border-slate-400 group-hover:bg-black peer-checked:bg-red-800 peer-checked:after:relative peer-checked:after:block peer-checked:after:content-[''] peer-checked:after:left-0 peer-checked:after:top-1 peer-checked:after:h-2 peer-checked:after:border-white peer-checked:after:border-r-0 peer-checked:after:border-b-4 peer-checked:after:border-l-4 peer-checked:after:border-t-0 peer-checked:after:origin-center peer-checked:after:-rotate-45"></span>
                </label>
              </li>
            </ul>
          </div>
          <div class="border-black border p-4 sm:mb-4">
            <h2 class="uppercase text-base font-semibold tracking-wide font-['Open_Sans', 'sans_serif'] text-grayDark border-black border-b py-2">states</h2>
            <ul class="max-h-80 text-veryDarkGray overflow-hidden overflow-y-scroll mt-6">
              <li v-for="state in states" class="my-1.5 text-base">
                <label class="uppercase font-semibold relative pl-9 block group">{{state.name}}
                  <input type="checkbox" class="peer opacity-0"  @click="checkedStates(state.abbreviation)">
                  <span class="absolute top-0 left-0 h-6 w-6 bg-white border border-slate-400 group-hover:bg-black peer-checked:bg-red-800 peer-checked:after:relative peer-checked:after:block peer-checked:after:content-[''] peer-checked:after:left-0 peer-checked:after:top-1 peer-checked:after:h-2 peer-checked:after:border-white peer-checked:after:border-r-0 peer-checked:after:border-b-4 peer-checked:after:border-l-4 peer-checked:after:border-t-0 peer-checked:after:origin-center peer-checked:after:-rotate-45"></span>
                </label>
              </li>
            </ul>
          </div>
          <div class="absolute top-0 right-[-40px] bg-darkRed p-2 md:hidden">
            <div @click="showListResults=false">
              <img src="/icons/left-arr-white.svg"  alt="arrow left"  width="20" height="20" :class="showListResults === true? 'flex':'hidden'">
            </div>
            <div @click="showListResults=true">
              <img src="/icons/right-arr-white.svg"  alt="arrow right"  width="20" height="20" :class="showListResults === true? 'hidden':'flex'">
            </div>
          </div>
        </div>
      </div>
      <div  class="grow">
        <div class="flex justify-between bg-black items-center px-4 py-2.5 mb-2 ">
          <input class="py-1 px-3 border focus:outline-none focus:ring-slate-500  focus:ring-slate-500 sm:min-w-[320px]"
                 placeholder="Search"
                 type="text"
                 v-model="search"
                 @input="searchProduct()">
          <select v-model='perPage' id='see_on_page'
                  class="py-1 px-3 border focus:outline-none focus:ring-slate-500 max-w-[70px] focus:border-slate-500">
            <option>12</option>
            <option>18</option>
            <option>24</option>
          </select>
          <!--            <div class="flex flex-row justify-end items-center">-->
          <!--              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">-->
          <!--                <path-->
          <!--                    d="M9.375 233.4l128-128c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H480c17.69 0 32 14.31 32 32s-14.31 32-32 32H109.3l73.38 73.38c12.5 12.5 12.5 32.75 0 45.25c-12.49 12.49-32.74 12.51-45.25 0l-128-128C-3.125 266.1-3.125 245.9 9.375 233.4z"-->
          <!--                    fill="#808080"/>-->
          <!--              </svg>-->
          <!--              <div v-for="index in numPages" :key="index">-->
          <!--                <button-->
          <!--                    class="h-7 w-7 text-xl inline-block text-center"-->
          <!--                    @click="currentPage=index-1"-->
          <!--                    :class="currentPage===index-1 ? 'text-white rounded-lg bg-darkRed' : 'text-black'"-->
          <!--                >{{ index }}-->
          <!--                </button>-->
          <!--              </div>-->
          <!--              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">-->
          <!--                <path-->
          <!--                    d="M502.6 278.6l-128 128c-12.51 12.51-32.76 12.49-45.25 0c-12.5-12.5-12.5-32.75 0-45.25L402.8 288H32C14.31 288 0 273.7 0 255.1S14.31 224 32 224h370.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z"-->
          <!--                    fill="#808080"/>-->
          <!--              </svg>-->
          <!--            </div>-->
        </div>

        <div class="flex flex-row flex-wrap justify-between">
          <div v-for="product in itemsPaginated" class=" bg-white p-4 text-center relative w-[48%] lg:w-[32%] m-[1%] lg:m-[0.5%] flex flex-col justify-between drop-shadow-md">

            <div class="flex flex-col">
              <div class="flex">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="w-5 inline-block">
                  <path
                      d="M147.8 192H480V144C480 117.5 458.5 96 432 96h-160l-64-64h-160C21.49 32 0 53.49 0 80v328.4l90.54-181.1C101.4 205.6 123.4 192 147.8 192zM543.1 224H147.8C135.7 224 124.6 230.8 119.2 241.7L0 480h447.1c12.12 0 23.2-6.852 28.62-17.69l96-192C583.2 249 567.7 224 543.1 224z"
                      fill="#B3121C"/>
                </svg>
                <span class="font-semibold ml-1.5">{{ product.category }}</span>
              </div>
              <div class="text-left min-h-[120px]">
                <h3 class="mt-2 text-3xl.5 font-semibold min-h-[68px]">{{ product.name }}</h3>
                <p class="font-normal text-grayMedium text-tiny">{{ product.service }}</p>
              </div>
            </div>
            <div class="flex justify-start">
              <front-jb-button
                  label="see more"
                  color="whiteNatonal"
                  class="text-white uppercase text-lg px-4 py-1.5  font-semibold mt-4 inline-block font-sans"
                  type="submit"
                  :to="'/directory-products-services/' +product.directory_url"
              />
            </div>
            <div class="absolute top-0 left-0 w-[4px] h-[20%] border-black bg-black border"></div>
          </div>
        </div>
        <div class=" p-4 mt-4 flex justify-between">
          <h2 class="uppercase text-base font-semibold tracking-wide font-['Open_Sans', 'sans_serif'] text-grayDark">1 - {{perPage}} / {{products.length}}</h2>
          <div class="flex flex-row justify-end items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">
              <path d="M9.375 233.4l128-128c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H480c17.69 0 32 14.31 32 32s-14.31 32-32 32H109.3l73.38 73.38c12.5 12.5 12.5 32.75 0 45.25c-12.49 12.49-32.74 12.51-45.25 0l-128-128C-3.125 266.1-3.125 245.9 9.375 233.4z" fill="#808080"/>
            </svg>
            <div v-for="index in numPages" :key="index">
              <button
                  class="h-7 w-7 text-xl inline-block text-center"
                  @click="currentPage=index-1"
                  :class="currentPage===index-1 ? 'text-white rounded-lg bg-darkRed' : 'text-black'"
              >{{ index }}
              </button>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6">
              <path d="M502.6 278.6l-128 128c-12.51 12.51-32.76 12.49-45.25 0c-12.5-12.5-12.5-32.75 0-45.25L402.8 288H32C14.31 288 0 273.7 0 255.1S14.31 224 32 224h370.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z" fill="#808080"/>
            </svg>
          </div>
        </div>

      </div>
    </div>

    <div v-else>
      <loaders-spinner/>
    </div>
  </div>
</template>
<script setup>

import {ref, computed} from "vue";
import {http} from "~/utils/http";
import {useMainStore} from '@/stores/main';
import {Tag} from "~/composables/nhTypes";
import useDebouncedRef from '~/composables/useDebouncedRef'
import {navigateTo} from "nuxt/app";

const ready = ref(false);
const categories = ref([]);
const states = ref([]);
const showListResults = ref();
const products = ref([]);
const items = ref([]);
const search = ref(null);
const perPage = ref(12);
const currentPage = ref(0);
const checked_states = ref([]);
const checked_categories = ref([]);
const numPages = computed(() => Math.ceil(items.value.length / perPage.value));
const itemsPaginated = computed(
    () => items.value.slice(perPage.value * currentPage.value, perPage.value * (currentPage.value + 1)));


const searchProduct = async()=>{
  if (search.value.length > 0) {
    items.value = [];
    products.value.forEach(product => {
      let name = product.name.toLowerCase();
      if (name.includes(search.value)) {
        items.value.push(product);
      }
    })
  } else {
    items.value = products.value;
  }
}

const checkedCategories = async(category) =>{
  let i = checked_categories.value.map(item => item).indexOf(category);
  if(i >= 0){
    checked_categories.value.splice(i,1);
  }else{
    checked_categories.value.push(category);
  }
  await verify();
}


const checkedStates = async (state) => {
  let i = checked_states.value.map(item => item).indexOf(state);
  if (i >= 0) {
    checked_states.value.splice(i, 1);
  } else {
    checked_states.value.push(state);
  }
  await verify();
}

const verify = async () => {
  if (checked_states.value.length > 0 || checked_categories.value.length > 0) {
    if (checked_states.value.length > 0 && checked_categories.value.length === 0) {
      items.value = [];
      checked_states.value.forEach(state => {
        products.value.forEach(product => {
          if (product.state === state) {
            items.value.push(product);
          }
        })
      })
    } else if (checked_states.value.length === 0 && checked_categories.value.length > 0) {
      items.value = [];
      checked_categories.value.forEach(category => {
        products.value.forEach(product => {
          if (product.category === category) {
            items.value.push(product);
          }
        })
      })
    } else if (checked_states.value.length > 0 && checked_categories.value.length > 0) {
      items.value = [];
      checked_states.value.forEach(state => {
        checked_categories.value.forEach(category => {
          products.value.forEach(product =>{
            if(product.state === state && product.category === category){
              items.value.push(product);
            }
          })
        })
      })
    }
  }else {
    items.value = products.value;
  }
}
  const getData = async () => {
    ready.value = false;
    await http.get('api/directory-listing', {params: {'listing_type': 'products_and_services'}})
        .then((response) => {
          categories.value = response.data.categories;
          states.value = response.data.states;
          products.value = response.data.products;
          let keep_state = [];

          products.value.forEach(product => {
            let i_state = states.value.map(item => item.abbreviation).indexOf(product.state);
            let index = keep_state.map(item => item.abbreviation).indexOf(product.state);
            if(!(index >= 0)){
              keep_state.push(states.value[i_state])
            }

            let i = categories.value.map(item => item.id).indexOf(product.category);
            if (i >= 0) {
              product.category = categories.value[i].name;
            } else {
              product.category = '';
            }
          })

          states.value = keep_state;
          items.value = products.value;
        })
    ready.value = true;
  }

getData();

</script>
<style>
.top-custom {
  bottom: 20px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 90px;
}
.custom-webkit-box{
  text-overflow: ellipsis;
  -webkit-line-clamp: 3 ;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 72px;
}
</style>
